import { ApiOperationItems } from "~enums/apiOperationItems";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { CreateDivision, UpdateDivision } from "~pages/Divisions/types/upsertDivision.ts";
import { useCreateDivision } from "./useCreateDivision.ts";
import { useDeleteDivision } from "./useDeleteDivision.ts";
import { useUpdateDivision } from "./useUpdateDivision.ts";

export const useDivisionService = () => {
  const { mutateAsync: createDivisionFn, isPending: isCreatePending } = useCreateDivision();
  const { mutateAsync: updateDivisionFn, isPending: isUpdatePending } = useUpdateDivision();
  const { mutateAsync: deleteDivisionFn, isPending: isDeletePending } = useDeleteDivision();

  const { create, update, remove } = useApiOperations(ApiOperationItems.DIVISION);

  const createDivision = (payload: CreateDivision) =>
    create(() => createDivisionFn(payload), {
      isSucceeded: () => true,
    });

  const updateDivision = (divisionId: string, payload: Omit<UpdateDivision, "divisionId">) =>
    update(() => updateDivisionFn({ ...payload, divisionId }));

  const deleteDivision = async (divisionId: string) => Boolean(await remove(() => deleteDivisionFn(divisionId)));

  return {
    createDivision,
    isCreatePending,
    updateDivision,
    isUpdatePending,
    deleteDivision,
    isDeletePending,
  };
};
